import useAuthUser from './useAuthUser';

const useAuthUserID = () => {
	const authUser = useAuthUser(['_id']);

	return authUser?._id;
};

export default useAuthUserID;
